// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
/* eslint-disable */
export const VERSION = {
    "dirty": false,
    "raw": "4985615",
    "hash": "4985615",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "4985615",
    "semverString": null,
    "version": "14.2.8"
};
/* tslint:enable */
